import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { FontFamilies } from "./SupportedFonts.js";
const GenerateFontFace = ({ font }) => {
  const { fontFamily, fontWeight, fontDisplay, fontLinks } = FontFamilies[font];
  if (fontLinks == null ? void 0 : fontLinks.google) return null;
  const fontSource = [
    (fontLinks == null ? void 0 : fontLinks.woff2) ? `url('${fontLinks.woff2.url}') format('woff2')` : null,
    (fontLinks == null ? void 0 : fontLinks.woff) ? `url('${fontLinks.woff.url}') format('woff')` : null,
    (fontLinks == null ? void 0 : fontLinks.otf) ? `url('${fontLinks.otf.url}') format('otf')` : null
  ].filter(Boolean).join(", ");
  return `
    @font-face {
      font-family: '${fontFamily}';
      src: ${fontSource};
      font-weight: ${fontWeight};
      font-display: ${fontDisplay};
    }`;
};
const FontsToStyles = ({ fonts }) => {
  if (!fonts) return null;
  const styles = fonts.map((font) => GenerateFontFace({ font })).join("\n");
  return /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: styles } });
};
const GoogleFontLink = ({ assetLink }) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }),
  /* @__PURE__ */ jsx("link", { href: assetLink, rel: "stylesheet" })
] });
const HostedFontLink = ({ assetLink }) => {
  return /* @__PURE__ */ jsx(
    "link",
    {
      rel: "preload",
      as: "font",
      href: assetLink,
      type: "font/woff2",
      crossOrigin: "anonymous"
    },
    assetLink
  );
};
const FontLoader = ({ fonts }) => /* @__PURE__ */ jsxs(Fragment, { children: [
  fonts.map((font) => {
    const { fontLinks } = FontFamilies[font];
    if (!fontLinks) return null;
    if (fontLinks.google) return /* @__PURE__ */ jsx(GoogleFontLink, { assetLink: fontLinks.google.url }, font);
    if (fontLinks.woff2) return /* @__PURE__ */ jsx(HostedFontLink, { assetLink: fontLinks.woff2.url }, font);
  }),
  /* @__PURE__ */ jsx(FontsToStyles, { fonts })
] });
export {
  FontLoader
};
